module.exports = __webpack_public_path__ + "static/img/banner-1.348927b5.png";